var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MobilePhonesModal } from "@/components/contacting/Modals/MobilePhonesModal";
import { useCallTracking } from "@/contexts/callTracking/hooks";
import { useClassified } from "@/contexts/classified";
import { useContactSections } from "@/contexts/contact";
import { useCustomerAction, useTrackingLeadInterestPhone } from "@/hooks";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { useTrackingLegacyLeadEvents } from "@/hooks/tracking/trackingLegacy";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { Box } from "@gemini/core";
import { PhoneIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useCallback, useEffect, useState } from "react";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
// should be deprecated in favor of PhoneButtonContainer
export const PhoneButton = ({ trackingAvZone, legacyTrackingInfos, rootTestId, isFullWidth, children, displayPhoneNumbers, iconOnly, onPress, showAsTextButton, variant = "secondary", size, }) => {
    var _a, _b, _c;
    const trackLeadPhoneInterestEvent = useTrackingLeadInterestPhone(trackingAvZone);
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const { legacyLeadConversionPhone } = useTrackingLegacyLeadEvents(); // Legacy GA3 for harvest
    const { fetchCallTrackingData, numberMappings, isCallTrackingRequestDone } = useCallTracking();
    const { customerActionExposeContactPhoneView, customerActionExposeContactPhoneCall, } = useCustomerAction();
    const legacyTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking;
    const isPreviewMode = useIsPreviewMode();
    const { phoneNumbers = [] } = (_c = (_b = useContactSections()) === null || _b === void 0 ? void 0 : _b.contactCard) !== null && _c !== void 0 ? _c : {};
    const [isCallTrackingLoading, setIsCallTrackingLoading] = useState(false);
    const [doNativeCall, setDoNativeCall] = useState(false);
    const hasLegacyTrackingData = !!legacyTrackingData;
    const nativeCall = useCallback(() => {
        var _a;
        const callNumber = ((_a = numberMappings === null || numberMappings === void 0 ? void 0 : numberMappings[0]) === null || _a === void 0 ? void 0 : _a.virtualPhoneNumber) || phoneNumbers[0];
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `tel:${callNumber === null || callNumber === void 0 ? void 0 : callNumber.replace(/\s/g, "")}`;
    }, [numberMappings, phoneNumbers]);
    const onPressDisplayPhoneNumbers = () => __awaiter(void 0, void 0, void 0, function* () {
        trackLeadPhoneInterestEvent();
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PHONE_NUMBER_DISPLAY);
        if (hasLegacyTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: legacyTrackingInfos },
            });
        }
        customerActionExposeContactPhoneView();
        if (!isCallTrackingRequestDone) {
            // @ts-ignore
            fetchCallTrackingData();
            setIsCallTrackingLoading(true);
        }
        onPress === null || onPress === void 0 ? void 0 : onPress();
    });
    const onPressCallNumber = (phoneNumber) => __awaiter(void 0, void 0, void 0, function* () {
        // eslint-disable-next-line no-restricted-globals
        if (typeof window === "undefined" || !phoneNumber)
            return;
        customerActionExposeContactPhoneView();
        customerActionExposeContactPhoneCall();
        trackLeadPhoneInterestEvent();
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PHONE_NUMBER_DISPLAY);
        if (hasLegacyTrackingData) {
            legacyLeadConversionPhone({
                eventData: { infos: legacyTrackingInfos },
            });
        }
        if (!isCallTrackingRequestDone) {
            // @ts-ignore
            fetchCallTrackingData();
            setIsCallTrackingLoading(true);
            setDoNativeCall(true);
        }
        else {
            nativeCall();
        }
    });
    useEffect(() => {
        setIsCallTrackingLoading(false);
        if (doNativeCall) {
            nativeCall();
            setDoNativeCall(false);
        }
    }, [isCallTrackingRequestDone, nativeCall, doNativeCall]);
    const getButtonSize = (iconOnly, size) => {
        if (size)
            return size;
        if (iconOnly)
            return "40";
    };
    const buttonSize = getButtonSize(iconOnly, size);
    return showAsTextButton ? (_jsxs(Box, { display: "flex", flexDirection: "row", gap: "spacing.8", cursor: "pointer", height: "sizing.40", alignItems: "center", testId: `${rootTestId}.PhoneButton`, onClick: () => displayPhoneNumbers
            ? onPressDisplayPhoneNumbers()
            : // @ts-ignore
                onPressCallNumber(phoneNumbers[0]), children: [_jsx(PhoneIcon, {}), _jsx(Box, { typography: "typography.body.16.boldUnderlined", children: children })] })) : (_jsx(Button, { iconOnly: iconOnly, size: buttonSize, isFullWidth: isFullWidth, testId: `${rootTestId}.PhoneButton`, variant: variant, iconPosition: "start", icon: PhoneIcon, onPress: () => displayPhoneNumbers
            ? onPressDisplayPhoneNumbers()
            : // @ts-ignore
                onPressCallNumber(phoneNumbers[0]), isLoading: isCallTrackingLoading, isDisabled: isPreviewMode, children: children }));
};
export const PhoneCTA = ({ trackingAvZone, legacyTrackingInfos, rootTestId, children, phoneNumbers, variant = "secondary", iconOnly, size, showAsTextButton, showModal = false, }) => {
    var _a;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formattedPhoneNumbers = (_a = phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.flatMap((number) => number.includes(" / ")
        ? number.split(" / ").map((n) => n.trim())
        : [number])) !== null && _a !== void 0 ? _a : [];
    const hasNoPhoneNumbers = (formattedPhoneNumbers === null || formattedPhoneNumbers === void 0 ? void 0 : formattedPhoneNumbers.length) === 0;
    // Return null if there are no phone numbers to display
    if (hasNoPhoneNumbers)
        return null;
    const hasMultiplePhoneNumbers = (formattedPhoneNumbers === null || formattedPhoneNumbers === void 0 ? void 0 : formattedPhoneNumbers.length) > 1;
    const showVersionWithModal = hasMultiplePhoneNumbers || showModal;
    return (_jsx(_Fragment, { children: showVersionWithModal ? (_jsxs(_Fragment, { children: [_jsx(PhoneButton, { onPress: () => setIsModalOpen(true), isFullWidth: true, trackingAvZone: trackingAvZone, legacyTrackingInfos: legacyTrackingInfos, rootTestId: rootTestId, displayPhoneNumbers: true, showAsTextButton: showAsTextButton, iconOnly: iconOnly, size: size, variant: variant, children: children }), _jsx(MobilePhonesModal, { onOpenChange: setIsModalOpen, isOpen: isModalOpen, phoneNumbers: formattedPhoneNumbers })] })) : (_jsx(PhoneButton, { isFullWidth: true, trackingAvZone: trackingAvZone, legacyTrackingInfos: legacyTrackingInfos, rootTestId: rootTestId, variant: variant, iconOnly: iconOnly, size: size, showAsTextButton: showAsTextButton, children: children })) }));
};
